import React from 'react';
import { MetricCard } from '@components/MetricCard';
import { DashboardMetric } from '../hooks';

interface DashboardStatsProps {
  metrics: DashboardMetric[];
}

export const DashboardStats: React.FC<DashboardStatsProps> = ({ metrics }) => {
  const getVariant = (index: number) => {
    const variants = ['primary', 'success', 'info', 'warning'] as const;
    return variants[index % variants.length];
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {metrics.map((metric, index) => (
        <MetricCard
          key={index}
          title={metric.title}
          value={metric.value}
          trend={metric.trend}
          trendType={metric.trendType}
          icon={metric.icon}
          variant={getVariant(index)}
        />
      ))}
    </div>
  );
};
